"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// filters
const dateFilter_1 = __importDefault(require("../filters/dateFilter"));
const dateConvDb2UiFilter_1 = __importDefault(require("../filters/dateConvDb2UiFilter"));
const dateConvUi2DbFilter_1 = __importDefault(require("../filters/dateConvUi2DbFilter"));
const dateTimeFilter_1 = __importDefault(require("../filters/dateTimeFilter"));
const dateTimeHumanFilter_1 = __importDefault(require("../filters/dateTimeHumanFilter"));
const timeConvDb2UiFilter_1 = __importDefault(require("../filters/timeConvDb2UiFilter"));
const timeConvUi2DbFilter_1 = __importDefault(require("../filters/timeConvUi2DbFilter"));
const timeFilter_1 = __importDefault(require("../filters/timeFilter"));
const fullNameFilter_1 = __importDefault(require("../filters/fullNameFilter"));
const linkifyFilter_1 = __importDefault(require("../filters/linkifyFilter"));
const truncateFilter_1 = __importDefault(require("../filters/truncateFilter"));
const normalizeHTMLFilter_1 = __importDefault(require("../filters/normalizeHTMLFilter"));
const stripTagsFilter_1 = __importDefault(require("../filters/stripTagsFilter"));
const vue_numerals_1 = __importDefault(require("vue-numerals"));
const wrappers_1 = require("quasar/wrappers");
exports.default = wrappers_1.boot(({ app }) => {
    app.config.globalProperties.$filters = {
        date: dateFilter_1.default,
        dateConvDb2Ui: dateConvDb2UiFilter_1.default,
        dateConvUi2Db: dateConvUi2DbFilter_1.default,
        time: timeFilter_1.default,
        timeConvDb2Ui: timeConvDb2UiFilter_1.default,
        timeConvUi2Db: timeConvUi2DbFilter_1.default,
        dateTime: dateTimeFilter_1.default,
        dateTimeHuman: dateTimeHumanFilter_1.default,
        fullname: fullNameFilter_1.default,
        linkify: linkifyFilter_1.default,
        truncate: truncateFilter_1.default,
        normalizeHTML: normalizeHTMLFilter_1.default,
        stripTags: stripTagsFilter_1.default
        /*
        currencyUSD(value) {
          return '$' + value
        }
        */
    };
    app.use(vue_numerals_1.default);
});
